import { EditIcon } from '@/assets/icons'
import { iconSizes } from '@/theme/tokens'
import React from 'react'
import { TripSummary } from '../core/destinations'
import { EditDestinationsButton, SummaryDetail, SummaryRange, SummaryRow } from './TripSummaryHeader.styles'

export interface TripSummaryHeaderProps {
	summary: TripSummary
	/** Absent in public mode, which has no way into the editor. */
	onEditDestinations?: () => void
}

/** The trip's span and size, heading the calendar, with the way into the destinations editor in member mode. */
const TripSummaryHeader: React.FC<TripSummaryHeaderProps> = ({ summary, onEditDestinations }) => (
	<SummaryRow>
		<div>
			<SummaryRange>{summary.range}</SummaryRange>
			<SummaryDetail>{summary.detail}</SummaryDetail>
		</div>
		{onEditDestinations && (
			<EditDestinationsButton type="button" aria-label="Edit destinations" onClick={onEditDestinations}>
				<EditIcon sx={{ fontSize: iconSizes.xs }} />
			</EditDestinationsButton>
		)}
	</SummaryRow>
)

export default TripSummaryHeader
